import styled from '@emotion/styled';
import { Divider } from 'antd';

export const DividerStyled = styled(Divider)`
  border-block-start: 1px solid ${({ theme }) => theme.COLORS.BLACK._700};
  margin: 30px 0;
`;
